// The advisor's choice of what the meeting shows.
//
// Preparation, not performance: this sits in the toolbar, never prints, and is
// not offered to a viewer. Each section of the report is a checkbox; the ones
// on by default are the September 3 meeting, and the rest are there for the
// household that needs them. A section the report did not produce for this
// household is listed and disabled rather than hidden, so the advisor can see
// why it is not on offer.

export default function MeetingPanel({ sections, count, onToggle }) {
  return (
    <details className="asmt-meeting no-print">
      <summary className="asmt-btn is-ghost asmt-meeting-summary">
        Meeting <span className="asmt-meeting-count">{count} {count === 1 ? 'section' : 'sections'}</span>
      </summary>
      <div className="asmt-meeting-list" role="group" aria-label="Sections in the meeting">
        {sections.map(s => (
          <label key={s.id} className={`asmt-meeting-item${s.available ? '' : ' is-absent'}`}>
            <input
              type="checkbox"
              checked={s.on}
              disabled={!s.available}
              onChange={e => onToggle(s.id, e.target.checked)}
            />
            <span>{s.label}</span>
            {!s.available && <span className="asmt-meeting-absent">not in this report</span>}
          </label>
        ))}
      </div>
    </details>
  );
}
